'use client';

import { c as _c } from "react/compiler-runtime";
import { DOCS__PERMISSIONS } from '@algoacademy/backend/modules/docs/permissions';
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { useAuth } from '@/app/_auth/useAuth';
import { ACCESS_TABS } from '@/app/baza/(main)/manage/_sections/Admin/_components/AccessTypeTabs';
import { AccessPreviewRow } from './AccessPreviewRow';
import { buildAccessPreviewItems } from './build-access-preview-items';
import type { CollectionAccessPreviewRole, CollectionAccessPreviewUser } from './types';
export type CollectionAccessPreviewProps = {
  assignedRoles?: CollectionAccessPreviewRole[];
  assignedUsers?: CollectionAccessPreviewUser[];
  isPublic?: boolean;
  requireManageAllPermission?: boolean;
};
export function CollectionAccessPreview(t0) {
  const $ = _c(17);
  const {
    assignedRoles: t1,
    assignedUsers: t2,
    isPublic: t3,
    requireManageAllPermission: t4
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const assignedRoles = t5;
  let t6;
  if ($[2] !== t2) {
    t6 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const assignedUsers = t6;
  const isPublic = t3 === undefined ? false : t3;
  const requireManageAllPermission = t4 === undefined ? true : t4;
  const {
    user
  } = useAuth();
  if (isPublic) {
    return null;
  }
  if (requireManageAllPermission && !user.hasPermissions([DOCS__PERMISSIONS.KNOWLEDGE_BASE.MANAGE.ALL])) {
    return null;
  }
  let t7;
  if ($[4] !== assignedRoles || $[5] !== assignedUsers) {
    t7 = buildAccessPreviewItems(assignedRoles, assignedUsers, true);
    $[4] = assignedRoles;
    $[5] = assignedUsers;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const editorItems = t7;
  let t8;
  if ($[7] !== assignedRoles || $[8] !== assignedUsers) {
    t8 = buildAccessPreviewItems(assignedRoles, assignedUsers, false);
    $[7] = assignedRoles;
    $[8] = assignedUsers;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const viewerItems = t8;
  if (editorItems.length === 0 && viewerItems.length === 0) {
    return null;
  }
  let t9;
  if ($[10] !== editorItems) {
    t9 = editorItems.length > 0 && <div className="space-y-2"><P3 className="text-contentTertiary">{ACCESS_TABS.MANAGE}</P3><AccessPreviewRow items={editorItems} /></div>;
    $[10] = editorItems;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== viewerItems) {
    t10 = viewerItems.length > 0 && <div className="space-y-2"><P3 className="text-contentTertiary">{ACCESS_TABS.VIEW}</P3><AccessPreviewRow items={viewerItems} /></div>;
    $[12] = viewerItems;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <div className="space-y-4">{t9}{t10}</div>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}